import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { Flow, Routes } from "@ctypes";
import { useNavigateToStep, useUser } from "@hooks";
import { i18n, Translations } from "@i18n";
import { Plus } from "./Plus";
import { useStyles } from "./styles";

export const EmptyCard = () => {
  const { hasBankAccount } = useUser();

  const navigate = useNavigateToStep();

  const styles = useStyles();

  const handleSubmit = () => {
    if (hasBankAccount) {
      navigate(Routes.AddBeneficiaryType, { state: { flow: Flow.Accounts } });
    } else {
      navigate(Routes.BankLinking, { state: { flow: Flow.B2B } });
    }
  };

  return (
    <div style={styles.container} onClick={handleSubmit}>
      <div style={styles.inner}>
        <Plus />
        <Spacing size={SpacingSizes.XS} />
        <Body>{i18n.t(Translations.AccountsRouteAddPerson)}</Body>
      </div>
    </div>
  );
};
